import { call, get, put, select } from "redux-saga/effects";
import * as commonAction from "../actions/common";
import api from "../services/httpUtilities/httpService";
import httpErrorHelpers from "../services/httpUtilities/httpErrorHelpers";

function* watcherGetDeliveryEnabledRequest() {
  try {
    const response = yield call(api.getCommonConfig);

    const { config } = response.data;

    if (response.status === 200) {
      yield put(commonAction.getDeliveryEnabledSuccess(config));
    }
  } catch (error) {
    yield call(httpErrorHelpers, error, commonAction.getDeliveryEnabledFailure);
  }
}

function* watcherGetCommonConfigRequest() {
  try {
    const response = yield call(api.getCommonConfig);

    const { config } = response.data;

    if (response.status === 200) {
      yield put(commonAction.getCommonConfigSuccess(config));
    }
  } catch (error) {
    yield call(httpErrorHelpers, error, commonAction.getCommonConfigFailure);
  }
}

function* watcherGetOccupationRequest() {
  try {
    const response = yield call(api.getOccupation);

    const { items } = response.data;
    if (response.status === 200) {
      yield put(commonAction.getOccupationSuccess(items));
    }
  } catch (error) {
    yield call(httpErrorHelpers, error, commonAction.getOccupationFailure);
  }
}

export {
  watcherGetDeliveryEnabledRequest,
  watcherGetCommonConfigRequest,
  watcherGetOccupationRequest
};



// WEBPACK FOOTER //
// ./src/sagas/common.js